module.exports = "<select\n  class=\"form-control\"\n  [(ngModel)]=\"value\">\n  <ng-content></ng-content>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/controls/select/select.component.html
// module id = ./src/app/shared/components/controls/select/select.component.html
// module chunks = main